import script from "./RestorePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./RestorePassword.vue?vue&type=script&setup=true&lang=js"

import "./RestorePassword.vue?vue&type=style&index=0&id=2b4fb754&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b4fb754"]])

export default __exports__